import React from 'react';
import { PermissionFlag } from 'v2/context/permissionFlagContext';
import { GenericObject, Permission } from 'v2/models';
import { PERMISSION_NAME } from 'v2/utils/permissions';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';
import { connect } from 'react-redux';

interface StateProps {
  permissions: { [key: string]: Permission };
}

type OriginatorProps = StateProps & ColumnComponentProps;

const OriginatorDetailed = ({ search, permissions }: OriginatorProps) => {
  return (
    <div className="title-for-review-search">
      <p>
        {`${search.submitted_by?.first_name} ${search.submitted_by?.last_name}`}
      </p>
      <p className="job-title">{search.submitted_by?.job_title}</p>
      <PermissionFlag
        permissions={permissions}
        namePermission={[PERMISSION_NAME.REVIEW_SEARCH_MASTER_ORG]}
      >
        <p className="classification">{search.organization?.name}</p>
      </PermissionFlag>
    </div>
  );
};

const mapStateToProps = (state: GenericObject): StateProps => {
  return {
    permissions: state.permissions.permissions,
  };
};

export default connect<StateProps>(mapStateToProps)(OriginatorDetailed);
